import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LangContext";
import "../styles/footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faInstagram, faFacebook, faXTwitter  } from "@fortawesome/free-brands-svg-icons";

export default function Footer() {
const [content, setContent] = useState({});
  const { lang } = useLang();

  const navigate = useNavigate();

  useEffect(() => {
    fetchPageContent("contact", lang).then(data => setContent(data));
  }, [lang]);

  if (!content) return <p>Loading...</p>;

   const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="footer">
      <div className="footer-main">
        {/* Left Section */}
        <img src="/logo.png" alt="Logo" className="footer-logo" onClick={() => navigate("/")} />
        <div className="footer-left">
          {content.name && (
            <h1 className="footer-company">{content.name}</h1>
            )}
            {content.email && (
              <a href={`mailto:${content.email}`} className="footer-email">
                <FontAwesomeIcon icon={faEnvelope} /> {content.email}
              </a>
            )}

            {content.instagram_link  && (
              <div className="footer-socials">
                {content.instagram_link && (
                  <a href={content.instagram_link} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                )}
                
                {content.facebook_link && (
                  <a href={content.facebook_link} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faFacebook} />
                  </a>
                )}
                {content.x_link && (
                  <a href={content.x_link} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faXTwitter} />
                  </a>
                )}
              </div>
            )}
          </div>

    {/* Finance Section */}
        {content.finance_title && content.finance_phone && (
          <div className="footer-section">
            <h3>{content.finance_title}</h3>
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhone} /> / 
              <FontAwesomeIcon icon={faWhatsapp} />
              <a href={`tel:+${content.finance_phone}`}>+{content.finance_phone}</a>
            </div>
          </div>
        )}

        {/* Translation Section */}
        {content.translation_title && content.translation_phone && (
          <div className="footer-section">
            <h3>{content.translation_title}</h3>
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhone} /> /
              <FontAwesomeIcon icon={faWhatsapp} />
              <a href={`tel:+${content.translation_phone}`}>+{content.translation_phone}</a>
            </div>
          </div>
        )}
      </div>


      {/* Bottom Copyright */}
      <div className="footer-bottom">
  <span
    role="link"
    tabIndex={0}
    onClick={() => navigate("/gdpr")}
    onKeyDown={(e) => e.key === "Enter" && navigate("/gdpr")}
  >
    © {currentYear} {content.name}. All rights reserved. {content.gdpr_title}
  </span>
</div>
    </footer>
  );
}